import { GetTagsParams, ListResourcesDto, PostGetAllParams } from "@evergis/api";
import { createResource } from "@evergis/react-fetching";
import { api as evergisApi } from "../evergis/api";

export const filesCatalog = createResource(
  ({ offset, limit, ...params }: PostGetAllParams & ListResourcesDto) =>
    async api => {
      return {
        data: await api.catalog.postGetAll({ offset, limit }, params),
      };
    },
  { injected: evergisApi },
);

export const resourcePermissions = createResource(
  (resourceId: string) => async api => {
    return {
      data: await api.catalog.getPermissions(resourceId),
    };
  },
  { injected: evergisApi },
);

export const catalogTags = createResource(
  (params: GetTagsParams) => async api => {
    return {
      data: await api.catalog.getTags(params),
    };
  },
  { injected: evergisApi },
);

export const catalogResource = createResource(
  (resourceId: string) => async api => {
    return {
      data: await api.catalog.getResource(resourceId),
    };
  },
  { injected: evergisApi },
);
